import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  OnInit,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterOutlet } from '@angular/router';
import { AuthSelectors, SetReturnUrl, SignInWithGoogle } from '@app/store';
import { Navigate } from '@ngxs/router-plugin';
import {
  ActionCompletion,
  Actions,
  ofActionCompleted,
  Store,
} from '@ngxs/store';
import { tap } from 'rxjs';

@Component({
  selector: 'app-auth-page',
  templateUrl: './auth.page.html',
  styleUrls: ['./auth.page.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet],
})
export class AuthPage implements OnInit {
  constructor(
    private actions$: Actions,
    private destroyRef: DestroyRef,
    private store: Store,
  ) {}

  protected returnUrl: string | undefined = this.store.selectSnapshot(
    AuthSelectors.returnUrl,
  );

  ngOnInit(): void {
    this.handleBackendResponse();
  }

  private handleBackendResponse(): void {
    this.actions$
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        ofActionCompleted(SignInWithGoogle),
        tap((actionCompletion: ActionCompletion) => {
          if (actionCompletion.result.successful) {
            this.store.dispatch(new SetReturnUrl(undefined));
            this.store.dispatch(new Navigate([this.returnUrl || '/account']));
          } else {
            this.store.dispatch(new Navigate(['/auth']));
          }
        }),
      )
      .subscribe();
  }
}
